var openBar = function (autofoco) {
    localStorage.setItem("acessibilidade_visible", true);
    $(".acessibility-bar ul").addClass("open");
    $(".with-acessibility-bar").addClass("open");

    if (autofoco) $(".acessibility-bar ul").find("li a:first").focus();
}

var closeBar = function () {
    localStorage.setItem("acessibilidade_visible", false);
    $(".acessibility-bar ul").removeClass("open");
    $(".with-acessibility-bar").removeClass("open");
}

var openAcessibilidade = function () {
    if ($(".acessibility-bar ul").hasClass("open")) {
        closeBar();
    } else {
        openBar(true);
    }
};

$(document).ready(function () {
    if (localStorage.getItem("acessibilidade_visible") === "true")
        openBar(false);
    else
        closeBar();
});